import { useState, useEffect } from "react"
import { useFormik } from 'formik'
import { object, string} from 'yup';
import { ArrowRightIcon, ArrowLeftIcon } from '@heroicons/react/24/outline'
import { fetchApi } from "./helpers"
import WarningModal from "../components-modals/WarningModal"
import ModasCuotasMes from "./ModalCuotas"
import AdmisionCursosSeleccionados from "./AdmisionCursosSeleccionados"
//comentario
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const AdminStep3 = ({
    datosInscripcionStep1,
    planesVentana,
    seleccionado,
    datosInscripcion,
    cuotas = [],
    Validar,
    setIsGrid,
    handleIdSeleccionado,
    obtenerDatosInscripcion,
    handleDatosFormNuevo,
    datosFormNuevo,
    rutaAlt,
    datosGradoParametro,
    haySolicitudSeleccionada,
    estadoAlumno
    , ...props }) => {

    /*
    obtenerDatosInscripcion(
        [e.target.name][0], //nombre del campo
        e.target.options[e.target.selectedIndex].text, //texto del campo
        e.target.value //value del campo
      );
      */

    const [modal, setModal] = useState({
        show: false,
        msg: '',
        ok: false,
    })
    const initialValues = {
        "Email": props.Email,
        "Dpi": props.Dpi,
    }

    const validationSchema = object({
        "Email": string().required('Dato obligatorio'),
        "Dpi":   string().required('Dato obligatorio'),
    })

    const formikProps = useFormik({
        initialValues,
        validationSchema
    })

    useEffect(() => {

        const datosEmails = async () => {
            formikProps.initialValues.Email = props.Email
            formikProps.initialValues.Dpi = props.Dpi

            await handleSolicitudesEmail(formikProps.values, formikProps.setFieldValue)

        }
        if (props.Email !== '' && props.Dpi !== '' && props.valido === 1) {
            datosEmails()
        }
    }, [])

    const handleSolicitudesEmail = async (values, setFieldValue) => {

        if (values.Email === '') {
            setModal({
                msg: 'Debes ingresar email, para continuar',
                ok: false,
                show: true
            })
        } else {
            if (values.Dpi === '') {
                setModal({
                    msg: 'Debes ingresar número de DPI, para continuar',
                    ok: false,
                    show: true
                })
            } else {
                setLoading(true);
                const res = await fetchApi({
                    url: props.url + '/utils/busquedas',
                    headers: props.headers,
                    content: {
                        opcion: "SOLICITUDES_EMAIL",
                        emailtutor: values.Email
                    }
                })
                setData(res)

                setLoading(false);// editar
                // setBloquar(true)
                setFieldValue('EmailE', values.Email)
                if (res.length > 0) {
                    setIsGrid(1)
                } else {
                    setIsGrid(2)
                }
            }
        }
    }

    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false)

    const [showForm, setShowForm] = useState(false)

    const handleCuotas = async (IdSolicitud, Cuota, Desc) => {
        setLoading(true);
        const res = await fetchApi({
            url: props.url + '/inscripciones/cuotasgral',
            headers: props.headers,
            content: {
                idsolicitud: IdSolicitud,
                cvariable: Cuota,
                descol: Desc
            }
        })

        setData(res)
        setLoading(false)
        setShowForm(true)
    }



    const handleAtras = (values) => {
        //setIsGrid(2)
        props.form = 2
        // 1: aparece el form para ingresar nuevo, 2: no aparece nada pero si damos clic en el boton, aparecen las solicitudes
        props.paso = 2

        handleDatosFormNuevo('', '', '', '', '', '', '', '', false)
        handleIdSeleccionado(true)
        props.valido = 1
        Validar(props)
    }

    const handleSubmit = () => {
        props.form = 4
        props.valido = 1
        props.paso = 2 // 3 para que se active el chequesito final
        handleIdSeleccionado(true)
        Validar(props) // Método pasado del AdmisionesIndex
    }

    return (
        <>

            <div className="sm:px-6 lg:px-8 bg-primarioMira p-5 pb-0 rounded-lg shadow-2xl divide-grisMira border border-grisMira">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className="text-lg font-semibold text-white">Descuentos obtenidos</h1>
                        <p className="text-sm text-grisMira">
                            Puedes optar a los siguientes descuentos  según la fecha en la que te inscribas.
                        </p>
                        <p className="text-sm text-grisMira">
                            Mientras más pronto te inscribas mejores descuentos obtendrás y el ahorro anual será mayor.
                        </p>
                        <p className="text-sm text-grisMira">
                            Para poder visualizar el detalle presiona sobre las colegiaturas.
                        </p>
                        <p className="text-sm text-grisMira">
                            Las cuotas variables que se muestran corresponden a la colegiatura de enero.
                        </p>
                        <p className="text-sm font-semibold text-secundario">
                            Recibirás un correo con más información para facilitar el proceso.
                        </p>
                        <p className="text-sm font-semibold text-secundario">
                            Si no lo ves en la bandeja de entrada recuerda revisar en correo no deseado. (Spam)
                        </p>
                        <p className="text-sm text-grisMira">
                            Recuerda que la cita no se agenda de forma automática en el sistema, debes llamar a la sede correspondiente.
                        </p>
                        <p className="text-sm text-grisMira">
                            Los períodos de descuentos siguen corriendo, son aplicados hasta el momento de la inscripción.
                        </p>
                        <p className="text-sm font-semibold text-secundario">
                            El pago de la Evaluación Diagnóstica no reserva su descuento.
                        </p>
                    </div>
                    <div className="block  lg:flex lg:w-[35%]">
                        <AdmisionCursosSeleccionados
                            //datosInscripcion={(seleccionado ? datosInscripcion : datosInscripcionStep1)}//{}
                            //datosInscripcion={(planesVentana.Carrera ? planesVentana : datosInscripcion)}//{}
                            datosInscripcion={(seleccionado ?
                                (planesVentana.Carrera ? planesVentana : datosInscripcion.Carrera ? datosInscripcion : datosGradoParametro)
                                : datosInscripcionStep1)}//{}
                        />
                    </div>
                </div>
                <div className="mt-2 flex flex-col ">
                    <div className="-mx-4 sm:-mx-6 lg:-mx-8 overflow-auto">
                        <div className="inline-block min-w-full align-middle">
                            <div className="shadow-sm ring-1 ring-black ring-opacity-5">
                                <table className="min-w-full border-separate divide-grisMira border border-grisMira" style={{ borderSpacing: 0 }}>
                                    <thead className="bg-secundarioMira">
                                        <tr>
                                            <th
                                                colSpan="2"
                                                className="sticky top-0 z-10 bg-secundarioMira border border-grisMira py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-grisMira"
                                            >
                                                FECHA DE INSCRIPCIÓN
                                            </th>
                                            <th
                                                colSpan="1"
                                                className="sticky top-0 z-10 bg-secundarioMira border border-grisMira py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-grisMira"
                                            >
                                                INSCRIPCIÓN PROMOCIONAL
                                                <br></br>
                                                <div className="text-secundario" >
                                                    {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(cuotas[0].Ins_Promocional)}
                                                </div>
                                            </th>
                                            <th
                                                colSpan="1"
                                                className="sticky top-0 z-10 bg-secundarioMira border border-grisMira py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-grisMira"
                                            >
                                                COLEGIATURA PROMOCIONAL
                                                <br></br>
                                                <div className="text-secundario" >
                                                    {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(cuotas[0].CVariable)}
                                                </div>
                                            </th>
                                            <th
                                                colSpan="2"
                                                className="sticky top-0 z-10 bg-secundarioMira border border-grisMira py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-grisMira"
                                            >
                                                VALORES A PAGAR
                                            </th>
                                            <th
                                                rowSpan="5"
                                                className="sticky top-0 z-10 bg-secundarioMira border border-grisMira py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-grisMira"
                                            >
                                                AHORRO ANUAL
                                            </th>
                                        </tr>
                                        <tr>
                                            <th
                                                scope="col"
                                                className="sticky top-0 z-10 bg-secundarioMira border border-grisMira py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-grisMira"
                                            >
                                                Del
                                            </th>
                                            <th
                                                scope="col"
                                                className="sticky top-0 z-10 bg-secundarioMira border border-grisMira py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-grisMira"
                                            >
                                                Al
                                            </th>
                                            <th
                                                scope="col"
                                                className="sticky top-0 z-10 bg-secundarioMira border border-grisMira py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-grisMira sm:pl-6 lg:pl-8"
                                            >
                                                Descuentos en inscripción
                                            </th>
                                            <th
                                                scope="col"
                                                className="sticky top-0 z-10 bg-secundarioMira border border-grisMira py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-grisMira sm:pl-6 lg:pl-8"
                                            >
                                                Descuentos en colegiatura
                                            </th>
                                            <th
                                                scope="col"
                                                className="sticky top-0 z-10 bg-secundarioMira  border border-grisMira px-3 py-3.5 text-center text-sm font-semibold text-grisMira "
                                            >
                                                En inscripción
                                            </th>
                                            <th
                                                scope="col"
                                                className="sticky top-0 z-10 bg-secundarioMira  border border-grisMira px-3 py-3.5 text-center text-sm font-semibold text-grisMira"
                                            >
                                                En colegiatura
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-secundarioMira">
                                        {cuotas.map((cuota, Idx) => <tr key={Idx} className={cuota.Activa && "bg-green-800"}>
                                            <td
                                                className={classNames(
                                                    Idx !== cuota.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                    'whitespace-nowrap py-2 pr-3 text-sm font-medium text-white text-center'
                                                )}
                                            >
                                                {cuota.FInicio}
                                            </td>
                                            <td
                                                className={classNames(
                                                    Idx !== cuota.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                    'whitespace-nowrap py-2 pr-3 text-sm font-medium text-white text-center'
                                                )}
                                            >
                                                {cuota.FFinal}
                                            </td>
                                            <td
                                                className={classNames(
                                                    Idx !== cuota.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                    'whitespace-nowrap py-2 pr-3 text-sm font-medium text-white text-center'
                                                )}
                                            >
                                                {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(cuota.Desc_Incrip)}
                                            </td>
                                            <td
                                                className={classNames(
                                                    Idx !== cuota.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                    'whitespace-nowrap py-2 pr-3 text-sm font-medium text-white text-center'
                                                )}
                                            >
                                                {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(cuota.Desc_Cole)}
                                            </td>
                                            <td
                                                className={classNames(
                                                    Idx !== cuota.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                    cuota.Activa ? "whitespace-nowrap py-2 pr-3  font-bold text-secundario text-base text-center" : "whitespace-nowrap py-2 pr-3 text-sm font-medium text-white text-center"
                                                )}
                                            >
                                                {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(cuota.InsPaga)}
                                            </td>
                                            <td
                                                className={classNames(
                                                    Idx !== cuota.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                    'whitespace-nowrap py-2 pr-3 text-sm font-medium text-white text-center'
                                                )}
                                            >
                                                <button
                                                    className='text-secundario hover:underline cursor-pointer'
                                                    onClick={() => handleCuotas(props.IdSoli, cuota.ColPaga, cuota.Desc_Cole)}
                                                    type="button"
                                                >
                                                    <div className="flex">
                                                        <ArrowRightIcon className={cuota.Activa ? "h-6 w-6 text-white " : "h-4 w-4 text-white "} aria-hidden="true" />
                                                        <p className={cuota.Activa ? "text-secundario font-bold text-base underline ml-1" : "ml-1"} >{Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(cuota.ColPaga)}</p>
                                                    </div>
                                                    <span className="sr-only">, {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(cuota.ColPaga)} </span>
                                                </button>
                                            </td>
                                            <td
                                                className={classNames(
                                                    Idx !== cuota.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                                    'whitespace-nowrap py-2 pr-3 text-sm font-medium text-white text-center'
                                                )}
                                            >
                                                {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(cuota.Ahorro_Anual)}
                                            </td>
                                        </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <WarningModal
                    open={loading ? true : false}

                    image={<img src={rutaAlt} alt='loading' />}
                    opacity='bg-opacity-100'
                />
                <ModasCuotasMes
                    open={showForm}
                    setOpen={setShowForm}
                    cuotasmes={data}
                />
                <div className="grid lg:grid-cols-6 lg:gap-6 grid-cols-2 gap-2 m-2">
                    <div className="sm:text-center col-span-[50%] lg:col-start-1 lg:col-end-2 lg:row-start-1">
                        <button
                            type="button"
                            className="relative w-full inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                            onClick={() => handleAtras(props)}
                        //onClick={() => Validar(1, 1, 1, IdSedeValido, IdPlanValido, IdCarreraValido, IdGradoValido, '', values.Email, values.Dpi)}
                        >
                            <div className="flex">
                                <ArrowLeftIcon className="h-5 w-5 text-white" aria-hidden="true" />
                            </div>
                            <p className="ml-1">Atrás</p>
                        </button>
                    </div>
                    {/*cuota.Activa&&"bg-azulBrillanteMira"*/}
                    {estadoAlumno === 'Prospecto' || estadoAlumno === 'Pendiente de pago' ?
                        <>
                            <div className="sm:text-center col-span-[50%] lg:col-start-4 lg:col-end-4 lg:row-start-1">
                                <button
                                    onClick={() => handleSubmit()}
                                    className="relative w-full inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                                >
                                    <div className="flex">
                                        <ArrowRightIcon className="h-5 w-5 text-white" aria-hidden="true" />
                                        <p className="ml-1">Continuar</p>
                                    </div>
                                </button>
                            </div>

                            <div className="col-span-full relative inline-flex justify-center lg:col-start-5 lg:col-end-7 row-start-1">
                                <p className="text-sm text-secundario">
                                    Puedes optar a cuotas niveladas o variables para obtener un mayor descuento. Para poder visualizar el detalle presiona sobre las colegiaturas.
                                </p>
                            </div>
                        </>
                        : null
                    }
                </div>
            </div>
        </>
    )
}

export default AdminStep3